import { formatDateTime } from '@/utils/formatter'
const dialog = {
    props: {
        visible: { type: Boolean, default: false },
        data: { type: Object, default: null }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        open(name = 'form') {
            //打开对话框先清除上次残留数据
            if (this.$refs[name]) {
                this.$refs[name].resetFields();
            }
            if (this.data) {
                let obj=this[name]
                for (let key in obj) {
                    obj[key] = this.data[key]
                }
            }
            //对话框打开后执行
            if (this.afterOpen && typeof (this.afterOpen) === 'function') {
                this.afterOpen()
            }
        },
        close() {
            if (!this.loading) {
                this.$emit("update:visible", false);
            }
            if (this.refresh) {
                this.$emit('refresh');
            }
        },
        show(attr, format) {
            if (this.data && (this.data[attr] || this.data[attr] == 0)) {
                if (format) {
                    return formatDateTime(this.data[attr])
                }
                return this.data[attr]
            } else {
                return ''
            }
        },
    }
}
export default dialog